import componentLoader from '../../../../../src/util/componentLoader';
// This file is auto-generated during the compilation
// Its contents here do not resemble the actual localeMap present in the application
// The actual localeMap looks as follows:

// module.exports = {
//     en_US: () => [
//         import(/* webpackMode: "lazy", webpackChunkName: "en_US" */ '<...1>/i18n/en_US.json'),
//         import(/* webpackMode: "lazy", webpackChunkName: "en_US" */ '<...2>/i18n/en_US.json')
//     ]
// }

export default {
    /** Contents of this object are auto-generated by `webpack-i18n-import-loader` */
    "sv_SE": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "sv_SE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/sv_SE.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "sv_SE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/sv_SE.json'),2)
] },
"sk_SK": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "sk_SK" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/sk_SK.json'),2)
] },
"ro_RO": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "ro_RO" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/ro_RO.json'),2)
] },
"pt_PT": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "pt_PT" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/pt_PT.json'),2)
] },
"pl_PL": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "pl_PL" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/pl_PL.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "pl_PL" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/pl_PL.json'),2)
] },
"nl_NL": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "nl_NL" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/nl_NL.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "nl_NL" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/nl_NL.json'),2)
] },
"nl_BE": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "nl_BE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/nl_BE.json'),2)
] },
"nb_NO": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "nb_NO" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/nb_NO.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "nb_NO" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/nb_NO.json'),2)
] },
"lv_LV": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "lv_LV" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/lv_LV.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "lv_LV" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/lv_LV.json'),2)
] },
"lt_LT": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "lt_LT" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/lt_LT.json'),2)
] },
"it_IT": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "it_IT" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/it_IT.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "it_IT" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/it_IT.json'),2)
] },
"hu_HU": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "hu_HU" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/hu_HU.json'),2)
] },
"fr_FR": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "fr_FR" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/fr_FR.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "fr_FR" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/fr_FR.json'),2)
] },
"fi_FI": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "fi_FI" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/fi_FI.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "fi_FI" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/fi_FI.json'),2)
] },
"et_EE": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "et_EE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/et_EE.json'),2)
] },
"es_ES": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "es_ES" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/es_ES.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "es_ES" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/es_ES.json'),2)
] },
"en_US": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "en_US" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/en_US.json'),2)
] },
"en_UK": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "en_UK" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/en_UK.json'),2)
] },
"en_IE": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "en_IE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/en_IE.json'),2)
] },
"en_GB": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "en_GB" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/en_GB.json'),2)
] },
"ee_EE": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "ee_EE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/ee_EE.json'),2)
] },
"de_DE": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "de_DE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/de_DE.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "de_DE" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/de_DE.json'),2)
] },
"de_CH": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "de_CH" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/de_CH.json'),2)
] },
"de_AT": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "de_AT" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/de_AT.json'),2)
] },
"da_DK": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "da_DK" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/da_DK.json'),2),
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "da_DK" */ '/var/www/vhosts/bodyapp/builds_tmp/984/node_modules/@scandipwa/scandipwa/i18n/da_DK.json'),2)
] },
"cs_CZ": function() { return [
componentLoader(() => import(/* webpackMode: "lazy", webpackChunkName: "cs_CZ" */ '/var/www/vhosts/bodyapp/builds_tmp/984/i18n/cs_CZ.json'),2)
] }
};
